"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionSchema = void 0;
const zod_1 = require("zod");
const IComponentFunctionSignal_1 = require("./IComponentFunctionSignal");
const IComponentFunctionAbstract_1 = require("./IComponentFunctionAbstract");
exports.IComponentFunctionSchema = IComponentFunctionAbstract_1.IComponentFunctionAbstractSchema.extend({
    functionSignals: zod_1.z.lazy(() => IComponentFunctionSignal_1.IComponentFunctionSignalSchema).array(),
});
//# sourceMappingURL=IComponentFunction.js.map